import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'kt-agreement-management',
  templateUrl: './agreement-management.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgreementManagementComponent {}
